import React, { useState } from 'react';

const UsuarioSelect = ({ usuarios, handleUsuarioSelecionado }) => {
  const [inputValue, setInputValue] = useState('');
  const [filteredUsuarios, setFilteredUsuarios] = useState([]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.trim() === '') {
        setFilteredUsuarios([]); // Esconde a lista se não digitou nada
        return;
      }

    const filtrados = usuarios.filter((u) =>
      u.cpf.includes(value)
    );
    setFilteredUsuarios(filtrados);
  };

  const handleSelect = (u) => {
    setInputValue(`${u.nome} - ${u.cpf}`);
    setFilteredUsuarios([]);
  
    const index = usuarios.findIndex((item) => item.id === u.id);
    handleUsuarioSelecionado(u, index);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        type="text"
        className="form-control"
        placeholder="Digite o CPF"
        value={inputValue}
        onChange={handleChange}
      />
      {filteredUsuarios.length > 0 && (
        <ul
          style={{
            position: 'absolute',
            zIndex: 999,
            background: 'white',
            border: '1px solid #ccc',
            width: '100%',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            maxHeight: '150px',
            overflowY: 'auto',
          }}
        >
          {filteredUsuarios.map((u) => (
            <li
              key={u.id}
              onClick={() => handleSelect(u)}
              style={{ padding: '5px', cursor: 'pointer' }}
            >
              {u.nome} - {u.cpf}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UsuarioSelect;
